<template lang="pug">
  text-counter#pv_person__memo(name="pv_person[memo]", :maxlength="maxlengths.memo", v-model="data", placeholder="人物に関する事柄などを入力してください。", data-testid="-personal-memo", @input="$emit('input', data)")
</template>

<script>
import TextCounter from '@/components/molecules/TextCounter'
export default {
  name: 'PvMemoForm',
  components: { TextCounter },
  props: {
    value: { type: String, required: true }
  },
  data () {
    return {
      data: '',
      maxlengths: {}
    }
  },
  watch: {
    value (newval, oldval) {
      if (newval !== oldval) {
        this.syncData(newval)
      }
    }
  },
  created () {
    this.maxlengths = this.loadMaxlengths('PvPersons')
    this.syncData(this.value)
  },
  methods: {
    syncData (data) {
      this.data = data
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/forms/PvMemoForm.vue